import React,{useState,useEffect} from 'react';
import sendReqUtil from './send-req-util';
const useQuota=(deps=[],isVisible=true)=>{
  const [quota,setQuota]=useState(-1);
  useEffect(()=>{
    if(!isVisible){
      return;
    }
    (async ()=>{
      const res=await sendReqUtil('/get-quota');
      if(res.body&&res.status===200){
        setQuota(res.body.quota);
      }
      else{
        console.assert(false);
      }
    })();
  },[...deps,isVisible]);
  return quota;
};
export {
  useQuota,
};

